<form class="form-container" autocomplete="on" [formGroup]="projectForm" (ngSubmit)="Submit()">
  <span class="label">Type of project:</span>
  <div class="container-horizontal">
    <button
      type="button"
      class="project-type-box container-horizontal"
      [ngClass]="{ 'project-type-box-active': isPrivate() }"
      (click)="setPrivate()"
    >
      <div class="icon-container">
        <mat-icon>lock</mat-icon>
      </div>
      <div>
        <h3>Private</h3>
        <span>People need permission to join</span>
      </div>
    </button>
    <button
      type="button"
      class="project-type-box container-horizontal"
      [ngClass]="{ 'project-type-box-active': isPublic() }"
      (click)="setPublic()"
    >
      <div class="icon-container">
        <mat-icon>language</mat-icon>
      </div>
      <div>
        <h3>Public</h3>
        <span>Anyone in your org can join</span>
      </div>
    </button>
  </div>

  <div class="container-vertical">
    <label for="name" class="label">Project name:</label>
    <input id="name" class="input" formControlName="name" />
    <label for="description" class="label">Description:</label>
    <textarea id="description" class="textarea" formControlName="description"></textarea>
  </div>

  <div class="container-horizontal">
    <div class="container-vertical">
      <span class="label">Business unit:</span>
      <mat-form-field class="iconf-select" appearance="outline">
        <mat-select formControlName="businessUnit" placeholder="select business unit" panelClass="topunit">
          @if (businessUnits$ | async; as businessUnits) { @for (units of businessUnits; track units) {
          <mat-option value="{{ units }}">{{ units }}</mat-option>
          } }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="container-vertical">
      <span class="label">Region:</span>
      <mat-form-field class="iconf-select" appearance="outline">
        <mat-select formControlName="region" (selectionChange)="regionUpdated()" placeholder="select region" panelClass="topunit">
          @if (geographicRegions$ | async; as regions) { @for (region of regions; track region) {
          <mat-option value="{{ region }}">{{ region }}</mat-option>
          } }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="container-horizontal">
    <div class="container-vertical">
      <span class="label">Country:</span>
      <mat-form-field class="iconf-select" appearance="outline">
        <mat-select formControlName="country" (selectionChange)="countryUpdated()" placeholder="select country" panelClass="topunit">
          @if (countries$ | async; as countries) { @for (country of countries; track country) {
          <mat-option value="{{ country }}">{{ country }}</mat-option>
          } }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="container-vertical">
      <span class="label">Location:</span>
      <mat-form-field class="iconf-select" appearance="outline">
        <mat-select formControlName="location" placeholder="select location" panelClass="topunit">
          @if (geographicLocations$ | async; as locations) { @for (location of locations; track location) {
          <mat-option value="{{ location }}">{{ location }}</mat-option>
          } }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="actions">
    <button class="iconf-btn-filled minh40 minw150" type="button" (click)="this.cancel.emit()">Cancel</button>
    <button class="iconf-btn-filled minh40 minw150" type="submit">{{ submitText }}</button>
  </div>
</form>
